import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

export default function LaborTab({
  totalBktHrs, totalInfraHrs, qaHrs, shipHrs,
  grandHrs, grandLabor, grandMat, laborRate, ohPct, margin,
  C, fmt, fmtHrs, pct,
}) {
  const categories = [
    { label: 'Bucket Assembly', hrs: totalBktHrs, color: C.blue || '#2563eb' },
    { label: 'Infrastructure', hrs: totalInfraHrs, color: C.orange || '#f59e0b' },
    { label: 'QA / Test', hrs: qaHrs, color: C.green || '#16a34a' },
    { label: 'Shipping', hrs: shipHrs, color: '#8b5cf6' },
  ];

  const maxHrs = Math.max(...categories.map((c) => c.hrs), 1);
  const effectiveRate = grandHrs > 0 ? grandLabor / grandHrs : 0;

  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      {/* Labor Breakdown */}
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 16 }}>Labor Breakdown by Category</div>

        {categories.map((cat) => (
          <div key={cat.label} style={{ marginBottom: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
              <span style={{ fontWeight: 600 }}>{cat.label}</span>
              <span style={{ color: '#64748b' }}>{fmtHrs(cat.hrs)}</span>
            </div>
            <div style={{ background: '#f1f5f9', borderRadius: 6, height: 22, overflow: 'hidden' }}>
              <div
                style={{
                  width: `${((cat.hrs / maxHrs) * 100).toFixed(1)}%`,
                  height: '100%',
                  background: cat.color,
                  borderRadius: 6,
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: 8,
                  color: '#fff',
                  fontSize: 11,
                  fontWeight: 600,
                  minWidth: cat.hrs > 0 ? 32 : 0,
                }}
              >
                {cat.hrs > 0 ? `${((cat.hrs / grandHrs) * 100).toFixed(0)}%` : ''}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Summary cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 16 }}>
        <div style={{ ...card, marginBottom: 0, textAlign: 'center', borderTop: `3px solid ${C.blue || '#2563eb'}` }}>
          <div style={{ fontSize: 11, color: '#64748b', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Total Hours
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: C.blue || '#2563eb' }}>{fmtHrs(grandHrs)}</div>
        </div>
        <div style={{ ...card, marginBottom: 0, textAlign: 'center', borderTop: `3px solid ${C.orange || '#f59e0b'}` }}>
          <div style={{ fontSize: 11, color: '#64748b', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Total Labor Cost
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: C.orange || '#f59e0b' }}>{fmt(grandLabor)}</div>
        </div>
        <div style={{ ...card, marginBottom: 0, textAlign: 'center', borderTop: `3px solid ${C.green || '#16a34a'}` }}>
          <div style={{ fontSize: 11, color: '#64748b', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Effective Rate
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: C.green || '#16a34a' }}>{fmt(effectiveRate)}/hr</div>
        </div>
      </div>

      {/* Rate detail */}
      <div style={card}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Rate Detail</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, fontSize: 13 }}>
          <div>Base Labor Rate: <strong>{fmt(laborRate)}/hr</strong></div>
          <div>OH & Burden: <strong>{pct(ohPct)}</strong></div>
          <div>Loaded Rate: <strong>{fmt(laborRate * (1 + ohPct))}/hr</strong></div>
          <div>Margin Target: <strong>{pct(margin)}</strong></div>
        </div>
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #e2e8f0', fontSize: 12, color: '#64748b' }}>
          Total Material: {fmt(grandMat)} &nbsp;|&nbsp; Total Labor: {fmt(grandLabor)}
          &nbsp;|&nbsp; Labor as % of Total: <strong>{pct(grandLabor / ((grandMat + grandLabor) || 1))}</strong>
        </div>
      </div>
    </div>
  );
}
